<template>
	<div class="content">
		<img src="../assets/bg.png" >
		<a class="beian" href="https://beian.miit.gov.cn" >© 版权所有 2021 | ©鲁ICP备19002451号</a>
	</div>
</template>

<script>
var timeId
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      isPc: false,
      id: '',
      banner1: [],
      banner: [],
      headerData: {
        logo: '',
        name: ''
      },
      info: {},
      page: 1,
      timeType: '', // 时间类型
      detailInfo: {
        live: {
          total: 0
        },
        company: {
          list: []
        }
      }, // 详细数据
      list: [],
      company: [],
      isGetting: false
    }
  },
  created () {
    
  },
  mounted () {
    // 截取id
   
  },
  methods: {
		
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	body {
		width: 100%;
	}
	*{
		padding: 0;
		margin: 0;
	}
	.content{
		position: relative;
	}
	.beian{
		position: absolute;
		bottom: 150px;
		left: 0;
		width: 100%;
		text-align: center;
		font-size: 16px;
		color: rgba(255,255,255,0.6);
		text-decoration: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue